<!--
 * @Author: Merlin
 * @Date: 2024-01-23 16:12:14
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-11 16:25:47
 * @Description: 这是头像按钮，其它组件调用这组件占位，将来再完善
-->

<template>
    <div class="user-avatar" >
        <img :src="sFinalSrc || emptyPic"
            @error="fnSetEmpty"
        >
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/user';
import { emptyPic } from '~/utils/constant';

const props = defineProps({
    size:{
        type: String,
        default: '20px',
    },
    self: {
        type: Boolean, // 显示用户【自己】的头像， 
    },
    src: {
        type: [String, Number], // 追加 Number 类型，防止因收到旧值数值0打印告警信息 
        default: '', // 准确指定头像文件 URL 
    },
    avatarName: {
        type: String, // 默认头像的文件名
        default: '',
    },
});

const userStore = useUserStore();
const oAvatar = getAvatars();

const sFinalSrc = computed(()=>{
    if (props.self) {
        if (userStore.avatar){
            return getTrueAvatar(userStore.avatar);
        }
        return sDefaultAvatarURL;
    }
    const sSrc = String(props.src || '');
    // ↓ 因偶见旧值 0, 或 "0" 所以这里判断长度大于 1 为合法头像路径 
    if (sSrc.length > 1) {
        return getTrueAvatar(sSrc);
    }
    if (oAvatar[props.avatarName]){
        return oAvatar[props.avatarName];
    }
    // ↓ 用默认头像兜底，防止有空白头像 
    return sDefaultAvatarURL;
});

const getTrueAvatar = (sUrl)=>{
    if (sUrl.startsWith(sDefaultAvatarPrefix)){
        const avatarName = sUrl.slice(
            sDefaultAvatarPrefix.length,
        );
        return oAvatar[avatarName];
    }
    return sUrl; 
}

const fnSetEmpty = (ev)=>{
    ev.target.src = emptyPic; 
}; 


onMounted(async ()=>{
    
});

</script>

<style scoped lang="scss">
.user-avatar{
    width: v-bind('size');
    height: v-bind('size');
    overflow: hidden;
    border-radius: 50%;
    background-color: rgba(255,255,255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    & > img{
        max-width: calc(100% + 2px);
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        object-fit: cover;
        object-position: center;
    }
}

</style>


